import Vue from 'vue';
import Vuex from 'vuex';

// Load modules
import user from './modules/user';
import featureFlag from './modules/st_feature_flag';
import misc from './modules/misc';
import dashboard from './modules/dashboard';

// Add logRocket and LogRocket vuex plugin
import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';

const logrocketPlugin = createPlugin(LogRocket);

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    featureFlag,
    misc,
    dashboard,
  },
  plugins: [logrocketPlugin]
});
